import _ from "lodash"

import { VariantId } from "shared/hubrise/ids"
import { IVariant } from "shared/hubrise/models"
import { updatedCatalog } from "shared/hubrise/utils/Catalog"
import * as Variant from "shared/hubrise/utils/Variant"

import type { Change, OperationContext } from "./types"

export type VariantOperations = {
  add(values: Partial<IVariant>): IVariant
  delete(variant: IVariant): void
  reorder(variants: Array<IVariant>): void
  update(id: VariantId, name: string, options?: { collapse?: boolean }): void
}

export default ({ catalog, pushState }: OperationContext): VariantOperations => ({
  add(values) {
    const { newCatalog, variant } = Variant.add(catalog, values)
    pushState(newCatalog, { model: "variant", operation: "add" })
    return variant
  },

  delete(variant) {
    const newCatalog = Variant.doDelete(catalog, variant)
    pushState(newCatalog, { model: "variant", operation: "delete", id: variant.id })
  },

  reorder(variants) {
    const newCatalog = updatedCatalog(catalog, { ...catalog, variants })
    const change: Change = {
      model: "variant",
      operation: "reorder",
    }
    pushState(newCatalog, change, (previousChange) => _.isEqual(previousChange, change))
  },

  update(id, name, { collapse = true } = {}) {
    const newCatalog = Variant.update(catalog, id, name)
    const change: Change = {
      model: "variant",
      id,
      operation: "update",
      fieldName: "name",
    }
    pushState(newCatalog, change, (previousChange) => collapse && _.isEqual(previousChange, change))
  },
})
